import { httpWithAuth } from '~/clients';
import { GET_CREDIT_STATUS } from '~/constants/endpoints';
import { CreditStatusResponse } from './contracts/FinanceData';

export default function fetchCreditStatus() {
  return httpWithAuth.get<CreditStatusResponse>(GET_CREDIT_STATUS, {
    headers: { 'X-Cvna-Finx-Clientsource': 'softpullMfe' }
  });
}
